// Module
var code = "<div class=\"ToolBarPreview\"> <label title=\"Tag\"> <i class=\"fa fa-tags\" aria-hidden=\"true\"></i> <!-- ko text: GetControlTypeTranslatedName() --><!-- /ko --> </label> </div>";
// Exports
export default code;